import * as axiosService from "./../axiosService";

export const getTopBarData = () => {
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetTopCardInfo`);
};

export const getFleetStatusInfo = () => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetFleetStatusInfo`);
 };

 export const getTripStatusInfo = () => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetTripStatusInfo`);
 };

 export const getActions = () => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetActions`);
 };

 export const getAlerts = () => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetAlerts`);
 };

 export const getMonthWiseTripsCount = (year) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetMonthWiseTripsCount?year=${year}`);
 };

 export const getInvoiceInfo = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetInvoiceInfo`,payload);
};

export const getTripInfo = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetTripInfo`,payload);
};

export const getProofOfDeliveryList = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetProofOfDeliveryList`,payload);
};


export const getDocumentUploadList = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetDocumentUploadList`,payload);
};
export const deleteAlerts = (payload) => {
   return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/DeleteAlert`,payload);
};


export const getNotificationCount = () => {
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetNotificationUnReadCount`);
};

export const getExpiredDocumentInfo = () => {
   return axiosService.Get(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Home/GetExpiredDocumentInfo`);
};

 
 

